import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { register } from "../api/auth";
import "./AuthPage.css";

export default function Register({ onLogin }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");
    const trimmedFirstName = firstName.trim();
    const trimmedLastName = lastName.trim();
    if (!trimmedFirstName || !trimmedLastName) {
      setError("Please enter your first and last name.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Your passwords do not match.");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await register({
        firstName: trimmedFirstName,
        lastName: trimmedLastName,
        username,
        password,
      });
      if (response.data?.token) {
        onLogin(response.data.token, username);
        navigate("/", { replace: true });
      } else {
        navigate("/login", { replace: true, state: { registered: true } });
      }
    } catch (requestError) {
      setError(requestError.response?.data?.message || requestError.message || "Unable to create your account. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <main className="auth-page">
      <Link className="auth-brand" to="/">
        <span className="brand-mark">Y</span>
        <span>Yants</span>
      </Link>
      <section className="auth-panel">
        <p className="auth-eyebrow">YANTS WORKSPACE</p>
        <h1>Create your account</h1>
        <p className="auth-intro">Join your community and take part in the conversation.</p>
        {error && <p className="auth-error" role="alert">{error}</p>}
        <form className="auth-form" onSubmit={handleSubmit}>
          <label htmlFor="register-first-name">First name</label>
          <input autoComplete="given-name" id="register-first-name" onChange={(event) => setFirstName(event.target.value)} required type="text" value={firstName} />
          <label htmlFor="register-last-name">Last name</label>
          <input autoComplete="family-name" id="register-last-name" onChange={(event) => setLastName(event.target.value)} required type="text" value={lastName} />
          <label htmlFor="register-email">Email</label>
          <input autoComplete="email" id="register-email" onChange={(event) => setUsername(event.target.value)} required type="email" value={username} />
          <label htmlFor="register-password">Password</label>
          <input autoComplete="new-password" id="register-password" minLength={8} onChange={(event) => setPassword(event.target.value)} required type="password" value={password} />
          <label htmlFor="register-confirm-password">Confirm password</label>
          <input autoComplete="new-password" id="register-confirm-password" onChange={(event) => setConfirmPassword(event.target.value)} required type="password" value={confirmPassword} />
          <button disabled={isSubmitting} type="submit">{isSubmitting ? "Creating account..." : "Create account"}</button>
        </form>
        <p className="auth-switch">Already have an account? <Link to="/login">Sign in</Link></p>
        <Link className="auth-back-link" to="/">Back to channels</Link>
      </section>
    </main>
  );
}